import Helper from './Helper';
import HeaderStateHandler from './HeaderStateHandler';

class ShareHandler {
  constructor() {
    this.toggler = this.constructor.getToggler();
    this.share = this.constructor.getShare();
    this.shareOpen = false;
    let title = document.querySelector('title');
    if(title){
      this.title = title.innerText;
    }
    this.url = window.location.href;
    this.image = '';
    if(this.toggler){
      this.bindEvents();
    }
  }

  bindEvents(){
    this.toggler.addEventListener('click', () => {
      this.togglerClicked();
    });
  }

  closeShare(){
    Helper.slideClose(this.share);
    Helper.removeClass(this.toggler, 'active');
  }

  static closeShare(){
    Helper.slideClose(this.getShare());
    Helper.removeClass(this.getToggler(), 'active');
  }

  openShare(){
    HeaderStateHandler.shareHandler();
    Helper.slideOpen(this.share);
    Helper.addClass(this.toggler, 'active');
    this.shareOpen = true;
  }

  togglerClicked(){
    if(this.constructor.isShareOpen()){
      this.constructor.closeShare();
    } else {
      this.openShare();
    }
  }


  static getToggler(){
    return document.querySelector('#js-share-toggler');
  }

  static getShare(){
    return document.querySelector('#js-header-share');
  }

  static isShareOpen(){
    return Helper.hasClass(this.getToggler(), 'active');
  }

} export default ShareHandler;
